import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';
import DeleteIcon from '@/assets/svg/trash.svg';
import Link from '@/components/Link';

import { CompareButtonProps } from './types';

function CompareButton({
  numberOfCompareCars,
  link,
  onReset,
}: CompareButtonProps) {
  return (
    <Component>
      <StyledLink to={link} target="_blank">
        Сравнить {numberOfCompareCars} авто
      </StyledLink>
      <DeleteButton onClick={onReset}>
        <DeleteIcon />
      </DeleteButton>
    </Component>
  );
}

export default CompareButton;

const Component = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(180deg, #f2cd62 0%, #f4bf26 100%);
  border-radius: 20px;
  cursor: pointer;
`;

const StyledLink = styled(Link)`
  flex: 1;
  padding: 12px 25px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
`;

const DeleteButton = styled.button`
  position: relative;
  padding: 12px 25px;
  border-left: 1px solid ${colors.black};

  svg {
    width: 20px;
    height: 20px;
    fill: ${colors.black};
  }
`;
